import { render } from "./PublicResetPassword.vue?vue&type=template&id=9566bd26&scoped=true"
import script from "./PublicResetPassword.vue?vue&type=script&lang=js"
export * from "./PublicResetPassword.vue?vue&type=script&lang=js"

import "./PublicResetPassword.vue?vue&type=style&index=0&id=9566bd26&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9566bd26"]])

export default __exports__